'use client'
import { memo } from 'react'
import styled from 'styled-components'
import Link from 'next/link'
import { motion } from 'motion/react'
import { mq, vw, getP50, createUnderline } from '@/styles'
import { staggerChildVariants, staggerWrapperVariants, imgVariants, basicVariantsProps } from '@/styles'
import { useTranslator } from '@/hooks'

interface ISectionContact {
  isProjects?: boolean
}

export const SectionContact = memo<ISectionContact>(({ isProjects = false }) => {
  const { t } = useTranslator()

  return (
    <Section>
      <TextWrapper variants={staggerWrapperVariants} {...basicVariantsProps} animate={'animate'}>
        <motion.h2 variants={staggerChildVariants}>{t('project.contact_section.title')}</motion.h2>
        <motion.div variants={staggerChildVariants} className={isProjects ? 'single' : ''}>
          <Link href='/contact'>{t('project.contact_section.contact_us')}</Link>
          {!isProjects && <Link href='/projects/all'>{t('project.contact_section.projects')}</Link>}
        </motion.div>
      </TextWrapper>
      <MediaWrapper>
        <motion.figure variants={imgVariants} animate={'animate'} initial={'initial'}>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img src='/images/contact.jpg' alt='contact background' loading='lazy'/>
        </motion.figure>
      </MediaWrapper>
    </Section>
  )
})


const Section = styled.section`
  background-color: var(--color-creme);
  display: grid;
  grid-template: 1fr 1fr / auto;
  margin: ${vw(130, 'mobile')} 0;
  width: 100vw;
  width: 100dvw;

  ${mq.greaterThan('tablet')}{
    margin: ${vw(150, 'desktop')} 0;
  }

  > *:first-child {
    grid-area: 1 / 1 / span 1 / span 1;
  }

  > *:last-child {
    grid-area: 2 / 1 / span 1 / span 1;
  }

  ${mq.greaterThan('tablet')}{
    grid-template: auto / 1fr 1fr;

    > *:last-child {
      grid-area: 1 / 2 / span 1 / span 1;
    }
  }
`

const MediaWrapper = styled.div`
  overflow: hidden;

  figure {
    height: ${vw(377, 'mobile')};
    position: relative;

    ${mq.greaterThan('tablet')}{
      height: ${vw(510, 'desktop')};
    }

    img { height: 100%; }
  }
`

const TextWrapper = styled(motion.div)`
  display: flex;
  flex-flow: column;
  justify-content: center;
  margin: 0 ${vw(65, 'mobile')};

  ${mq.greaterThan('tablet')}{
    display: block;
    margin: 0;
  }

  h2 {
    ${getP50()}
    margin-bottom: ${vw(40, 'mobile')};

    ${mq.greaterThan('tablet')}{
      margin: ${vw(129, 'desktop')} ${vw(128, 'desktop')} ${vw(60, 'desktop')} ${vw(156, 'desktop')};
    }
  }

  > div {
    display: flex;
    justify-content: space-evenly;

    &.single {
      justify-content: center;
    }

    ${mq.greaterThan('tablet')}{
      justify-content: center;

      a {
        margin-right: ${vw(20, 'desktop')};
      }
    }

    a {
      ${createUnderline({ reverse: true })}
    }
  }
`